export default __webpack_public_path__ + "static/9-16ed2f111b4fb8029656c419a76c125f.png";